import React from "react";
import { ariaDescribedByIds, examplesId, getInputProps, } from "@rjsf/utils";
import clsx from "clsx";
export default function BaseInputTemplate({ id, placeholder, required, readonly, disabled, type, value, onChange, onChangeOverride, onBlur, onFocus, autofocus, options, schema, rawErrors = [], children, extraProps, }) {
    const inputProps = {
        ...extraProps,
        ...getInputProps(schema, type, options),
    };
    const _onChange = ({ target: { value } }) => onChange(value === "" ? options.emptyValue : value);
    const _onBlur = ({ target: { value } }) => onBlur(id, value);
    const _onFocus = ({ target: { value } }) => onFocus(id, value);
    const inputClass = clsx("block p-2.5 w-full text-sm text-gray-900 rounded-lg bg-transparent border-0 border-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer", rawErrors.length > 0 ? "border-red-500" : "border-muted-foreground");
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { id: id, name: id, type: type, placeholder: placeholder, 
            // biome-ignore lint/a11y/noAutofocus: <explanation>
            autoFocus: autofocus, required: required, disabled: disabled, readOnly: readonly, className: inputClass, list: schema.examples ? examplesId(id) : undefined, ...inputProps, value: value || value === 0 ? value : "", onChange: onChangeOverride || _onChange, onBlur: _onBlur, onFocus: _onFocus, "aria-describedby": ariaDescribedByIds(id, !!schema.examples) }),
        children,
        Array.isArray(schema.examples) ? (React.createElement("datalist", { id: examplesId(id) }, schema.examples
            .concat(schema.default && !schema.examples.includes(schema.default)
            ? [schema.default]
            : [])
            // biome-ignore lint/suspicious/noExplicitAny: <explanation>
            .map((example) => {
            return React.createElement("option", { key: example, value: example });
        }))) : null));
}
//# sourceMappingURL=BaseInputTemplate.js.map